import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ClickOutside from "vue-click-outside";
import VueCookie from "vue-cookie";
import BootstrapVue from "bootstrap-vue";
import "@/connect";

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

import VuePlyr from "vue-plyr";
import "vue-plyr/dist/vue-plyr.css";

import VueToast from "vue-toast-notification";
// Import one of available themes
import "vue-toast-notification/dist/theme-default.css";

import VTooltip from 'v-tooltip'
// import '@/assets/introjs-custom.scss'

// import VueCompositionAPI from '@vue/composition-api'

import "intro.js/introjs.css";
import "@/assets/introjs-custom.scss";

// use plugin
Vue.use(VTooltip)

Vue.use(VueToast);

Vue.use(VuePlyr);

Vue.use(BootstrapVue);

Vue.use(VueCookie);

Vue.use(ClickOutside);

// Vue.use(VueCompositionAPI)

Vue.config.productionTip = false;

Vue.config.devtools = true;

// This callback runs before every route change, including on page load.
router.beforeEach((to, from, next) => {
  // This goes through the matched routes from last to first, finding the closest route with a title.
  // eg. if we have /some/deep/nested/route and /some, /deep, and /nested have titles, nested's will be chosen.
  const nearestWithTitle = to.matched
    .slice()
    .reverse()
    .find((r) => r.meta && r.meta.title);

  // Find the nearest route element with meta tags.
  const nearestWithMeta = to.matched
    .slice()
    .reverse()
    .find((r) => r.meta && r.meta.metaTags);
  const previousNearestWithMeta = from.matched
    .slice()
    .reverse()
    .find((r) => r.meta && r.meta.metaTags);

  // If a route with a title was found, set the document (page) title to that value.
  if (nearestWithTitle) document.title = nearestWithTitle.meta.title;

  // Remove any stale meta tags from the document using the key attribute we set below.
  Array.from(document.querySelectorAll("[data-vue-router-controlled]")).map(
    (el) => el.parentNode.removeChild(el)
  );

  // Skip rendering meta tags if there are none.
  if (!nearestWithMeta) return next();

  // Turn the meta tag definitions into actual elements in the head.
  nearestWithMeta.meta.metaTags
    .map((tagDef) => {
      const tag = document.createElement("meta");

      Object.keys(tagDef).forEach((key) => {
        tag.setAttribute(key, tagDef[key]);
      });

      // We use this to track which meta tags we create, so we don't interfere with other ones.
      tag.setAttribute("data-vue-router-controlled", "");

      return tag;
    })
    .forEach((tag) => document.head.appendChild(tag));

  next();
});

// window.addEventListener('dragenter', function (e) {
//   console.log(e.dataTransfer.files)
//   console.log(e.target)
//   e.dataTransfer.dropEffect = 'none'
//   e.dataTransfer.effectAllowed = 'none'
//   e.preventDefault()
//   return false
// })

window.addEventListener("dragover", function (e) {
  let dropzone = e.target.closest("[dropzone]");
  if (!dropzone) {
    e.preventDefault();
    e.dataTransfer.effectAllowed = "none";
    e.dataTransfer.dropEffect = "none";
  }
});

let shift = false;
let control = false;

window.onkeydown = (e) => {
  switch (e.keyCode) {
    case 17:
      control = true;
      break;
    case 16:
      shift = true;
      break;
    case 80:
      if (shift && control) {
        e.preventDefault();
        e.stopPropagation();
      }
      break;
    default:
      shift = false;
      control = false;
      break;
  }
};

Vue.prototype.$sizeFormat = (bytes) => {
  const sizes = ["Bytes", "KB", "MB", "GB", "TB"];
  if (bytes === 0) return "0 Bytes";
  const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10);
  if (i === 0) return `${bytes} ${sizes[i]}`;
  return `${(bytes / 1024 ** i).toFixed(1)} ${sizes[i]}`;
};

Vue.prototype.$spaceFormat = (totalBytes, bytes, unit) => {
  if (bytes === 0) return "0";

  if (unit === "MB") {
    let mb = 1048576 * bytes;
    return totalBytes - mb;
  }

  if (unit === "GB") {
    let gb = 1073741824 * bytes;
    return totalBytes - gb;
  }
};

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
